import { Dialog } from '@mui/material';
import { APPROVAL_TYPES, COMITEE_TYPES } from 'lib/api/approvals/types';
import { EvaluationReviews } from 'lib/common/EvaluationDetails';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { validatePermissions } from 'lib/functions/utils';
import MultiChatWindowContainer from 'pages/Finance/Components/Financing/common/chat';
import Committee from 'pages/Finance/Components/Financing/common/Comittee';
import { ComiteeTabProvider } from 'pages/Finance/Components/Financing/common/Comittee/ComiteeTabProvider';
import FilesDialog from 'pages/Finance/Components/Financing/common/filesView';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { AuthState } from 'services/redux/authSlice';

import CreditDeleteModal from '../../../../../Factoring/components/Recieved/components/ShoppingDialog/components/Summary/components/DialogActionWrapper/components/CreditDeleteModal';
import Documents from './components/Documents';
import PaymentModule from './components/PaymentModule';
import Summary from './components/Summary';
import CreditRequestUpdateStatusModal from './components/UpdateStatusModal';

export interface UpdateStatusTransitions {
  [key: string]: { key: string; label: string }[];
}

const ShoppingDialogRecieved = (props: any) => {
  const {
    shoppingCartType,
    openShoppingCart,
    setOpenShoppingCart,
    setUp,
    openRequest,
    setSelectedRequest,
    setSuccessOpen,
    setFailureOpen,
    executiveCreating,
    onClose,
  } = props;
  const [openFiles, setOpenFiles] = useState(false);
  const [startValue, setStartValue] = useState(0);
  const [goToRiskTimes, setGoToRiskTimes] = useState(1);
  const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const goToRisk = () => {
    setStartValue(1);
    setGoToRiskTimes(goToRiskTimes + 1);
  };

  const goToSummary = () => {
    setStartValue(0);
  };

  const handleOpenDeleteConfirmModal = () => {
    setOpenDeleteConfirm(true);
  };

  const handleOpenUpdateStatusModal = () => {
    setOpenUpdateStatusModal(true);
  };

  const updateStatusTransitions: UpdateStatusTransitions = {
    Aceptada: [
      {
        key: 'IN_REVIEW',
        label: 'En revisión',
      },
    ],
    'En giro': [
      ...(openRequest.comiteeOperationsId
        ? [
            {
              key: 'ACCEPTED',
              label: 'Aceptada',
            },
          ]
        : [
            {
              key: 'IN_REVIEW',
              label: 'En revisión',
            },
          ]),
    ],
  };

  const canEditRequest = () => {
    if (
      !updateStatusTransitions[openRequest.status] ||
      updateStatusTransitions[openRequest.status].length === 0
    )
      return false;
    if (!validatePermissions(user, 'financing_creditRequest_edit_status'))
      return false;
    return true;
  };

  const comiteeTabInfo = {
    requestType: APPROVAL_TYPES.CREDIT_REQUEST,
    comiteeType: COMITEE_TYPES.RISK,
    requestId: openRequest.id,
    comiteeId: openRequest.comiteeId,
    canEdit: openRequest.status === 'En revisión',
    isRejected: openRequest.status === 'Rechazada',
    isActive: ['En giro', 'Activa', 'Completada'].includes(openRequest.status),
    refreshRequest: () => {
      setSuccessOpen('Aprobación actualizada correctamente');
      return setUp();
    },
  };

  const tabs = [
    {
      index: 0,
      label: 'Resumen',
      component: (
        <Summary
          shoppingCartType={shoppingCartType}
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          setUp={setUp}
          openRequest={openRequest}
          setSelectedRequest={setSelectedRequest}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          executiveCreating={executiveCreating}
          goToRisk={goToRisk}
          setLoading={setLoading}
          handleOpenDeleteConfirmModal={handleOpenDeleteConfirmModal}
          handleOpenUpdateStatusModal={handleOpenUpdateStatusModal}
          canEditRequest={canEditRequest}
        />
      ),
    },
    {
      index: 1,
      label: 'Documentos',
      component: (
        <Documents
          documents={openRequest?.documents || []}
          documentsToApply={openRequest?.documentsToApply || []}
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
    {
      index: 1,
      label: 'Aprobación',
      disabled: ['Revisada'].includes(openRequest?.status),
      component: (
        <ComiteeTabProvider info={comiteeTabInfo}>
          <Committee />
        </ComiteeTabProvider>
      ),
      path: 'recieved',
    },
    {
      index: 1,
      label: 'Riesgo',
      component: (
        <EvaluationReviews
          requestEntries={[
            { requestId: openRequest.id, requestType: 'credit-request' },
          ]}
        />
      ),
      path: 'recieved',
    },
    {
      index: 2,
      label: 'Archivos',
      component: (
        <FilesDialog
          openRequest={openRequest}
          openFiles={openFiles}
          setOpenFiles={setOpenFiles}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          executiveCreating={executiveCreating}
          requestType="creditRequest"
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
    {
      index: 2,
      label: 'Giro',
      component: (
        <PaymentModule
          selectedRequest={openRequest}
          setSelectedRequest={setSelectedRequest}
          setOpenShoppingCart={setOpenShoppingCart}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          goToSummary={goToSummary}
        />
      ),
      path: 'recieved',
      disabled: !['En giro', 'Activa', 'Completada'].includes(
        openRequest?.status,
      ),
    },
    {
      index: 3,
      label: 'Chat',
      component: (
        <MultiChatWindowContainer
          selectedRequest={openRequest}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          requestType="creditRequest"
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
  ];

  if (openRequest && openRequest.status === 'REJECTED') {
    tabs.pop();
  }

  if (executiveCreating) {
    tabs.pop();
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={openShoppingCart}>
      <div style={{ padding: 20, minHeight: 200 }}>
        <EnhancedTab
          title={
            !executiveCreating
              ? `Crédito #${openRequest?.id}`
              : 'Nueva solicitud'
          }
          startValue={startValue}
          tabs={tabs}
          updater={goToRiskTimes}
          onTabChange={setStartValue}
        />
        {startValue === 0 && !loading && (
          <div
            style={{
              display: 'flex',
              gap: '10px',
              marginLeft: 'auto',
              marginBottom: '-25px',
            }}
          >
            {/* <Typography
              color={canDelete ? "error" : "text.disabled"}
              variant="body1"
              fontWeight="bold"
              style={{
                cursor: canDelete ? 'pointer' : 'not-allowed',
                position: 'relative',
                top: -32,
                opacity: canDelete ? 1 : 0.5,
              }}
              onClick={canDelete ? () => handleOpenDeleteConfirmModal() : undefined}
            >
              Eliminar
            </Typography> */}
            {openDeleteConfirm && (
              <CreditDeleteModal
                open={openDeleteConfirm}
                setOpen={setOpenDeleteConfirm}
                requestId={openRequest.id}
                onClose={onClose}
                setUp={setUp}
                setSuccessOpen={setSuccessOpen}
                setFailureOpen={setFailureOpen}
                setOpenShoppingCart={setOpenShoppingCart}
              />
            )}
          </div>
        )}
      </div>
      {openDeleteConfirm && (
        <CreditDeleteModal
          open={openDeleteConfirm}
          setOpen={setOpenDeleteConfirm}
          requestId={openRequest.id}
          onClose={onClose}
          setUp={setUp}
          setOpenShoppingCart={setOpenShoppingCart}
        />
      )}
      {openUpdateStatusModal && (
        <CreditRequestUpdateStatusModal
          updateStatusTransitions={updateStatusTransitions}
          open={openUpdateStatusModal}
          setOpen={setOpenUpdateStatusModal}
          requestId={openRequest.id}
          setUp={setUp}
          oldStatus={openRequest.status}
          selectedId={openRequest.id}
        />
      )}
    </Dialog>
  );
};

export default ShoppingDialogRecieved;
